export const twilightTokens = {
    tokens: {
        blendBackground: '#11efe3',
        blendIntersection: '#0048e5',
        blendForeground: '#9966ff',
        gradientColorZero: '#4436ff',
        gradientColorOne: '#56f',
        gradientColorTwo: '#d679ff',
        gradientColorThree: '#11efe3',
        gradientColorZeroTransparent: '#4436ff00',
        gradientColorOneTransparent: '#5566ff00',
        gradientColorTwoTransparent: '#d679ff00',
        gradientColorThreeTransparent: '#04ffff00',
        shadeOneColor: '#16cbe1',
        shadeTwoColor: '#20b5e3',
        shadeThreeColor: '#1086db',
        shadeFourColor: '#1959e6',
        shadeFiveColor: '#9966ff',
        shadeSixColor: '#002c59'
    },
    themeTokens: {
        dark: {
            blendBackground: '#11efe3',
            blendIntersection: '#c2ffff',
            blendForeground: '#9966ff'
        }
    },
    accents: {
        purple: {
            tokens: {
                accentColor: '#9966ff'
            }
        },
        teal: {
            tokens: {
                accentColor: '#00c4c4'
            }
        }
    }
};

//# sourceMappingURL=Twilight.js.map